// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Account_accountChild__w0C0V {
	max-width: 482px;
	width: 100%;
}

.Account_theme__guFYr {
	color: #350505;
	font-family: Manrope;
	font-size: 35px;
	font-style: normal;
	font-weight: 600;
	line-height: 109.523%; /* 38.333px */
}

.Account_ssoParent__K8AeQ {
	margin-top: 50px;
}

.Account_orCon__sNKGO {
	margin-top: 35px;
}

.Account_orStrike__k\\+weV {
	top: 15px;
	/* bottom: auto; */
	left: 0;
	/* height: 0px; */
	flex-shrink: 0;
	strokewidth: 0.5px;
	stroke: #b2b2b2;
}

.Account_orTxtCon__fklxC {
	padding: 5px 23px;
	height: 30px;
	flex-shrink: 0;
	background: #fff;
	z-index: 500;
}

.Account_orTxt__fK2WN {
	color: #494747;
	text-align: center;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 300;
	line-height: 125%; /* 20px */
}

.Account_form__OxQ7B {
	margin-top: 35px;
}

.Account_inputFieldCon__OiWQY {
	gap: 15px;
}

.Account_submitBtn__3Kgl8 {
	margin-top: 28px;
	height: 60px;
	flex-shrink: 0;
	border-radius: 5px;
	border: 1px solid #052E26;
	background: #052E26;
	color: #fff;
	text-align: center;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 36px; /* 200% */
}

.Account_rememberToForget__BfaGu {
	margin-top: 10px;
}

.Account_rememberInput__5nZvl {
	visibility: hidden;
}

.Account_rememberCon__4TLWq {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
	border-radius: 5px;
	border: 1px solid #073142;
}

.Account_rememberLabel__ku5uO {
	color: #5f5f5f;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 36px; /* 257.143% */
}

.Account_doRemember__Yu\\+zz {
	background: #073142;
}

.Account_remember__bCa8v {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
}

.Account_forgot__nu96V {
	color: #737373;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 36px; /* 257.143% */
}

.Account_strike__kaMPP {
	margin-top: 32px;
	/* height: 0px; */
	flex-shrink: 0;
	strokewidth: 0.5px;
	stroke: #b2b2b2;
}

.Account_instead__-D2Jr {
	margin-top: 28px;
	color: #494747;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 125%; /* 20px */
}

.Account_alt__r4LQ0 {
	color: #494747;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 125%;
}

.Account_extraTextCon__NARGZ {
	background: rgba(90, 34, 130, 0.05);
	/* max-width: 601px; */
	width: 41%;
	position: relative;
	/* height: 100vh; */
}

.Account_extraTextInnerCon__F6GkN {
	padding: 0 72px 80px;
	height: 100vh;
	position: sticky;
	top: 0;
	left: 0;
}

.Account_bigTxt__Yh0Qa {
	color: #2b2b2b;
	font-family: 'Clash Display';
	font-size: 45px;
	font-style: normal;
	font-weight: 400;
	line-height: 109.523%; /* 65.714px */
}

.Account_noteCon__DPpbn {
	margin-top: 31px;
}

.Account_noteStrike__KdTRv {
	top: 16px;
	left: 0;
	height: 0;
	border: 1.3px solid #000000;
	width: calc(100% - 337px);
}

.Account_note__YXI\\+5 {
	max-width: 327px;
	width: 100%;
	/* height: 63px; */
	flex-shrink: 0;
	color: #494747;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 130%; /* 20.8px */
}

.Account_actualContent__0ZQ\\+x {
	padding-left: 20px;
	padding-right: 20px;
	width: 59%;
	padding-bottom: 80px;
	height: initial;
}

.Account_scrollable__5yAfy {
	min-height: 100vh !important;
	overflow-y: scroll;
}

.Account_notice__ZKALh {
	color: #737373;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px; /* 157.143% */
}

.Account_resetBtnCon__BTC4L {
	margin-top: 28px;
}

.Account_retraceSteps__IAmYp {
	display: flex;
	width: 86px;
	height: 60px;
	padding: 19px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-shrink: 0;
	border-radius: 5px;
	border: 1px solid var(--neutral-colors-500, #e0e0e9);
	background: var(--neutral-colors-white, #fff);
}

.Account_retrace__dY0ab {
	width: 30px;
	height: 30px;
	flex-shrink: 0;
}

.Account_proceedToForget__004i6 {
	max-width: calc(100% - 96px);
	width: 100%;
	height: 60px;
	flex-shrink: 0;
	border-radius: 5px;
	border: 1px solid #052E26;
	background: #052E26;
	color: #fff;
	text-align: center;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 36px; /* 200% */
}

.Account_proceedToForgetFull__aOiBE {
	max-width: initial !important;
}

.Account_emailIcon__xmKzh {
	width: 127px;
	height: 113.945px;
	flex-shrink: 0;
	margin-bottom: 31px;
}

.Account_proceedDisabled__cM-5m {
	background: rgba(90, 34, 130, 0.2) !important;
	border-color: rgba(90, 34, 130, 0.1) !important;
}

.Account_rMessageCon__nVNLW {
	margin-top: 24px;
}

.Account_resendMessage__ZoXD9 {
	color: #737373;
	text-align: center;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px; /* 157.143% */
}

.Account_resendToEmail__2oQTg {
	color: #1c1c1c;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 22px;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
	.Account_extraTextInnerCon__F6GkN {
		padding: 0 25px 20px;
	}

	.Account_bigTxt__Yh0Qa {
		font-size: 25px !important;
	}

	.Account_noteStrike__KdTRv {
		display: none !important;
	}

	.Account_noteCon__DPpbn {
		/* display: none !important; */
		margin-top: 20px !important;
		justify-content: flex-start !important;
	}
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
	.Account_extraTextInnerCon__F6GkN {
		padding: 0 45px 80px;
	}

	.Account_bigTxt__Yh0Qa {
		font-size: 50px !important;
	}

	.Account_noteStrike__KdTRv {
		display: none !important;
	}

	.Account_note__YXI\\+5 {
		width: 100% !important;
	}
}

@media only screen and (max-width: 820px) {
	.Account_extraTextCon__NARGZ {
		display: none !important;
	}

	.Account_actualContent__0ZQ\\+x {
		width: 100%;
		padding-bottom: 80px;
	}

	.Account_accountChild__w0C0V.Account_onVerifyMobile__nnsZw {
		flex-direction: column !important;
		min-height: 100vh !important;
	}

	.Account_flexColumnOne__Powe5 {
		flex: 1 1 !important;
		height: 100% !important;
		justify-content: space-around !important;
	}

	.Account_strike__kaMPP.Account_onVerifyMobile__nnsZw {
		display: none !important;
	}
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
	.Account_extraTextCon__NARGZ {
		display: none !important;
	}

	/* .input.password {
		max-width: 200px;
	} */

	.Account_miniCon__lK6aN {
		flex-direction: column;
		gap: 15px;
	}

	.Account_actualContent__0ZQ\\+x {
		padding-left: 30px;
		padding-right: 30px;
		width: 100%;
		padding-bottom: 40px;
	}

	.Account_theme__guFYr {
		color: #181818;
		font-family: Manrope;
		font-size: 22px;
		font-style: normal;
		font-weight: 700;
		line-height: 109.523%; /* 24.095px */
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
	.Account_extraTextCon__NARGZ {
		display: none !important;
	}

	.Account_actualContent__0ZQ\\+x {
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		padding-bottom: 20px;
	}
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Account.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,OAAO;CACP,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,mCAAmC;CACnC,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,aAAa;CACb,gBAAgB;CAChB,MAAM;CACN,OAAO;AACR;;AAEA;CACC,cAAc;CACd,4BAA4B;CAC5B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,OAAO;CACP,SAAS;CACT,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,UAAU;CACV,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,kBAAkB;CAClB,oDAAoD;CACpD,6CAA6C;AAC9C;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,6CAA6C;CAC7C,+CAA+C;AAChD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA,yDAAyD;AACzD;CACC;EACC,oBAAoB;CACrB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;CACvC;AACD;;AAEA;CACC;EACC,oBAAoB;CACrB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,WAAW;EACX,oBAAoB;CACrB;;CAEA;EACC,iCAAiC;EACjC,4BAA4B;CAC7B;;CAEA;EACC,oBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;CACzC;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;;IAEG;;CAEH;EACC,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;CACrB;;CAEA;EACC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE,aAAa;CACrC;AACD;;AAEA;AACA;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;CACrB;AACD;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".accountChild {\n\tmax-width: 482px;\n\twidth: 100%;\n}\n\n.theme {\n\tcolor: #350505;\n\tfont-family: Manrope;\n\tfont-size: 35px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 109.523%; /* 38.333px */\n}\n\n.ssoParent {\n\tmargin-top: 50px;\n}\n\n.orCon {\n\tmargin-top: 35px;\n}\n\n.orStrike {\n\ttop: 15px;\n\t/* bottom: auto; */\n\tleft: 0;\n\t/* height: 0px; */\n\tflex-shrink: 0;\n\tstrokewidth: 0.5px;\n\tstroke: #b2b2b2;\n}\n\n.orTxtCon {\n\tpadding: 5px 23px;\n\theight: 30px;\n\tflex-shrink: 0;\n\tbackground: #fff;\n\tz-index: 500;\n}\n\n.orTxt {\n\tcolor: #494747;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: 125%; /* 20px */\n}\n\n.form {\n\tmargin-top: 35px;\n}\n\n.inputFieldCon {\n\tgap: 15px;\n}\n\n.submitBtn {\n\tmargin-top: 28px;\n\theight: 60px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tborder: 1px solid #052E26;\n\tbackground: #052E26;\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 36px; /* 200% */\n}\n\n.rememberToForget {\n\tmargin-top: 10px;\n}\n\n.rememberInput {\n\tvisibility: hidden;\n}\n\n.rememberCon {\n\twidth: 20px;\n\theight: 20px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tborder: 1px solid #073142;\n}\n\n.rememberLabel {\n\tcolor: #5f5f5f;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 36px; /* 257.143% */\n}\n\n.doRemember {\n\tbackground: #073142;\n}\n\n.remember {\n\twidth: 18px;\n\theight: 18px;\n\tflex-shrink: 0;\n}\n\n.forgot {\n\tcolor: #737373;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 36px; /* 257.143% */\n}\n\n.strike {\n\tmargin-top: 32px;\n\t/* height: 0px; */\n\tflex-shrink: 0;\n\tstrokewidth: 0.5px;\n\tstroke: #b2b2b2;\n}\n\n.instead {\n\tmargin-top: 28px;\n\tcolor: #494747;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 125%; /* 20px */\n}\n\n.alt {\n\tcolor: #494747;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 125%;\n}\n\n.extraTextCon {\n\tbackground: rgba(90, 34, 130, 0.05);\n\t/* max-width: 601px; */\n\twidth: 41%;\n\tposition: relative;\n\t/* height: 100vh; */\n}\n\n.extraTextInnerCon {\n\tpadding: 0 72px 80px;\n\theight: 100vh;\n\tposition: sticky;\n\ttop: 0;\n\tleft: 0;\n}\n\n.bigTxt {\n\tcolor: #2b2b2b;\n\tfont-family: 'Clash Display';\n\tfont-size: 45px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 109.523%; /* 65.714px */\n}\n\n.noteCon {\n\tmargin-top: 31px;\n}\n\n.noteStrike {\n\ttop: 16px;\n\tleft: 0;\n\theight: 0;\n\tborder: 1.3px solid #000000;\n\twidth: calc(100% - 337px);\n}\n\n.note {\n\tmax-width: 327px;\n\twidth: 100%;\n\t/* height: 63px; */\n\tflex-shrink: 0;\n\tcolor: #494747;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 130%; /* 20.8px */\n}\n\n.actualContent {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n\twidth: 59%;\n\tpadding-bottom: 80px;\n\theight: initial;\n}\n\n.scrollable {\n\tmin-height: 100vh !important;\n\toverflow-y: scroll;\n}\n\n.notice {\n\tcolor: #737373;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 22px; /* 157.143% */\n}\n\n.resetBtnCon {\n\tmargin-top: 28px;\n}\n\n.retraceSteps {\n\tdisplay: flex;\n\twidth: 86px;\n\theight: 60px;\n\tpadding: 19px;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 10px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tborder: 1px solid var(--neutral-colors-500, #e0e0e9);\n\tbackground: var(--neutral-colors-white, #fff);\n}\n\n.retrace {\n\twidth: 30px;\n\theight: 30px;\n\tflex-shrink: 0;\n}\n\n.proceedToForget {\n\tmax-width: calc(100% - 96px);\n\twidth: 100%;\n\theight: 60px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tborder: 1px solid #052E26;\n\tbackground: #052E26;\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 36px; /* 200% */\n}\n\n.proceedToForgetFull {\n\tmax-width: initial !important;\n}\n\n.emailIcon {\n\twidth: 127px;\n\theight: 113.945px;\n\tflex-shrink: 0;\n\tmargin-bottom: 31px;\n}\n\n.proceedDisabled {\n\tbackground: rgba(90, 34, 130, 0.2) !important;\n\tborder-color: rgba(90, 34, 130, 0.1) !important;\n}\n\n.rMessageCon {\n\tmargin-top: 24px;\n}\n\n.resendMessage {\n\tcolor: #737373;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 22px; /* 157.143% */\n}\n\n.resendToEmail {\n\tcolor: #1c1c1c;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 22px;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n\t.extraTextInnerCon {\n\t\tpadding: 0 25px 20px;\n\t}\n\n\t.bigTxt {\n\t\tfont-size: 25px !important;\n\t}\n\n\t.noteStrike {\n\t\tdisplay: none !important;\n\t}\n\n\t.noteCon {\n\t\t/* display: none !important; */\n\t\tmargin-top: 20px !important;\n\t\tjustify-content: flex-start !important;\n\t}\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n\t.extraTextInnerCon {\n\t\tpadding: 0 45px 80px;\n\t}\n\n\t.bigTxt {\n\t\tfont-size: 50px !important;\n\t}\n\n\t.noteStrike {\n\t\tdisplay: none !important;\n\t}\n\n\t.note {\n\t\twidth: 100% !important;\n\t}\n}\n\n@media only screen and (max-width: 820px) {\n\t.extraTextCon {\n\t\tdisplay: none !important;\n\t}\n\n\t.actualContent {\n\t\twidth: 100%;\n\t\tpadding-bottom: 80px;\n\t}\n\n\t.accountChild.onVerifyMobile {\n\t\tflex-direction: column !important;\n\t\tmin-height: 100vh !important;\n\t}\n\n\t.flexColumnOne {\n\t\tflex: 1 !important;\n\t\theight: 100% !important;\n\t\tjustify-content: space-around !important;\n\t}\n\n\t.strike.onVerifyMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.extraTextCon {\n\t\tdisplay: none !important;\n\t}\n\n\t/* .input.password {\n\t\tmax-width: 200px;\n\t} */\n\n\t.miniCon {\n\t\tflex-direction: column;\n\t\tgap: 15px;\n\t}\n\n\t.actualContent {\n\t\tpadding-left: 30px;\n\t\tpadding-right: 30px;\n\t\twidth: 100%;\n\t\tpadding-bottom: 40px;\n\t}\n\n\t.theme {\n\t\tcolor: #181818;\n\t\tfont-family: Manrope;\n\t\tfont-size: 22px;\n\t\tfont-style: normal;\n\t\tfont-weight: 700;\n\t\tline-height: 109.523%; /* 24.095px */\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n\t.extraTextCon {\n\t\tdisplay: none !important;\n\t}\n\n\t.actualContent {\n\t\tpadding-left: 20px;\n\t\tpadding-right: 20px;\n\t\twidth: 100%;\n\t\tpadding-bottom: 20px;\n\t}\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountChild": `Account_accountChild__w0C0V`,
	"theme": `Account_theme__guFYr`,
	"ssoParent": `Account_ssoParent__K8AeQ`,
	"orCon": `Account_orCon__sNKGO`,
	"orStrike": `Account_orStrike__k+weV`,
	"orTxtCon": `Account_orTxtCon__fklxC`,
	"orTxt": `Account_orTxt__fK2WN`,
	"form": `Account_form__OxQ7B`,
	"inputFieldCon": `Account_inputFieldCon__OiWQY`,
	"submitBtn": `Account_submitBtn__3Kgl8`,
	"rememberToForget": `Account_rememberToForget__BfaGu`,
	"rememberInput": `Account_rememberInput__5nZvl`,
	"rememberCon": `Account_rememberCon__4TLWq`,
	"rememberLabel": `Account_rememberLabel__ku5uO`,
	"doRemember": `Account_doRemember__Yu+zz`,
	"remember": `Account_remember__bCa8v`,
	"forgot": `Account_forgot__nu96V`,
	"strike": `Account_strike__kaMPP`,
	"instead": `Account_instead__-D2Jr`,
	"alt": `Account_alt__r4LQ0`,
	"extraTextCon": `Account_extraTextCon__NARGZ`,
	"extraTextInnerCon": `Account_extraTextInnerCon__F6GkN`,
	"bigTxt": `Account_bigTxt__Yh0Qa`,
	"noteCon": `Account_noteCon__DPpbn`,
	"noteStrike": `Account_noteStrike__KdTRv`,
	"note": `Account_note__YXI+5`,
	"actualContent": `Account_actualContent__0ZQ+x`,
	"scrollable": `Account_scrollable__5yAfy`,
	"notice": `Account_notice__ZKALh`,
	"resetBtnCon": `Account_resetBtnCon__BTC4L`,
	"retraceSteps": `Account_retraceSteps__IAmYp`,
	"retrace": `Account_retrace__dY0ab`,
	"proceedToForget": `Account_proceedToForget__004i6`,
	"proceedToForgetFull": `Account_proceedToForgetFull__aOiBE`,
	"emailIcon": `Account_emailIcon__xmKzh`,
	"proceedDisabled": `Account_proceedDisabled__cM-5m`,
	"rMessageCon": `Account_rMessageCon__nVNLW`,
	"resendMessage": `Account_resendMessage__ZoXD9`,
	"resendToEmail": `Account_resendToEmail__2oQTg`,
	"onVerifyMobile": `Account_onVerifyMobile__nnsZw`,
	"flexColumnOne": `Account_flexColumnOne__Powe5`,
	"miniCon": `Account_miniCon__lK6aN`
};
export default ___CSS_LOADER_EXPORT___;
